



























import Vue, { PropOptions } from 'vue';
import SideBarItem from './SideBarItem.vue';

export interface ISideMenuItem {
  itemID: string;
  groupingID: number;
  parentID?: number;
  name: string;
  path: string;
  only?: boolean;
}

export default Vue.extend({
  name: 'SideMenuBase',
  components: {
    SideBarItem,
  },
  props: {
    list: Array as PropOptions<ISideMenuItem[]>,
    setItemID: String,
  },
  watch: {
    setItemID: {
      immediate: true,
      handler(v) {
        this.selectedID = v;
      },
    },
    list: {
      immediate: true,
      handler() {
        const parentList = this.list.filter(v2 => !v2.itemID || v2.only);
        this.parentList = parentList;

        const childList = this.list.filter(v2 => v2.itemID);
        this.childList = childList;
      },
    },
  },
  data() {
    return {
      selectedID: '' as any,
      parentList: [] as ISideMenuItem[],
      childList: [] as ISideMenuItem[],
    };
  },
  methods: {
    getParentID(v: ISideMenuItem) {
      return v.groupingID;
    },
    getChildID(v: ISideMenuItem) {
      return v.itemID;
    },
    getItemText(v: ISideMenuItem) {
      return v.name;
    },
  },
});
